import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import MembGameSvcMnyApi from 'Apis/MembGameSvcMnyApi';
import "Assets/css/GameMnyDpst.css";
import DpstOdrInfotApi from 'Apis/DpstOdrInfotApi';
import EtcCtxtApi from 'Apis/EtcCtxtApi';
import MgpStore from 'Stores/Store';
import ShopDpstResultLayer from 'Components/ShopDpstResultLayer';

const getParamCI = (params: URLSearchParams, key: string): string | null => {
    const targetKey = key.toLowerCase();
    let result: string | null = null;
    params.forEach((v, k) => {
        if (k.toLowerCase() === targetKey) {
            result = v;
        }
    });
    return result;
};

const GameMnyDpstResult = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { data: langData }: any = UseLangLstQuery();
    const queryParams = new URLSearchParams(location.search);
    
    // 기본은 navigation state를 우선 사용하고, 모바일 현재창 결제 복귀 시 URL 파라미터를 fallback으로 사용한다.
    const dpstOdrNo = location.state?.dpstOdrNo || getParamCI(queryParams, 'dpstOdrNo');
    const dpstCode = location.state?.dpstCode || getParamCI(queryParams, 'code') || getParamCI(queryParams, 'dpstCode');
    const dpstMsg = location.state?.dpstMsg || getParamCI(queryParams, 'msg') || getParamCI(queryParams, 'dpstMsg');
    const gameSvcCd = location.state?.gameSvcCd || getParamCI(queryParams, 'gameSvcCd') || 'BBO';
    const pymtMthdNm = location.state?.pymtMthdNm || getParamCI(queryParams, 'pymtMthdNm');
    const rcmnPrdtCd = location.state?.rcmnPrdtCd || getParamCI(queryParams, 'rcmnPrdtCd');
    const prdtNm = location.state?.prdtNm || getParamCI(queryParams, 'prdtNm');
    const paidMny = location.state?.paidMny || getParamCI(queryParams, 'pm');
    const freeMny = location.state?.freeMny || getParamCI(queryParams, 'fm');
    const odrAmt = location.state?.odrAmt || getParamCI(queryParams, 'oa');
    const lang = location.state?.lang || getParamCI(queryParams, 'langCd') || 'ko';
    const hasResultPayload = Boolean(dpstOdrNo || dpstCode || dpstMsg);
    
    const [gameSvcMnyState, setGameSvcMnyState] = useState("");
    const [isResultLoading, setIsResultLoading] = useState(true);
    const [dpstOdrInfoState, setDpstOdrInfoState] = useState<any>(null);
    const [pymtGuideCtxtState,setPymtGuideCtxtState] = useState("");

    useEffect(() => {
        const targetW = 500;
        const targetH = 730;
        let attempts = 0;
        const maxAttempts = 8;

        const tryResize = () => {
            attempts += 1;
            try {
                if (typeof window.resizeTo === 'function') {
                    window.resizeTo(targetW, targetH);
                }

                if (typeof window.moveTo === 'function') {
                    const left = Math.max(0, Math.round((window.screen.availWidth - targetW) / 2));
                    const top = Math.max(0, Math.round((window.screen.availHeight - targetH) / 2));
                    window.moveTo(left, top);
                }

                const ow = typeof window.outerWidth === 'number' ? window.outerWidth : window.innerWidth;
                const oh = typeof window.outerHeight === 'number' ? window.outerHeight : window.innerHeight;
                const ok = Math.abs((ow || 0) - targetW) <= 4 && Math.abs((oh || 0) - targetH) <= 6;
                console.info('Popup resize attempt', attempts, { ow, oh, ok });
                if (ok || attempts >= maxAttempts) {
                    clearInterval(timer);
                    if (!ok) console.warn('Could not resize popup — browser may block programmatic resizing.');
                }
            } catch (e) {
                console.error('Popup resize/move failed', e);
                if (attempts >= maxAttempts) clearInterval(timer);
            }
        };

        // try immediately and then retry a few times (some browsers only allow resize after load/user gesture)
        tryResize();
        const timer = setInterval(tryResize, 300);

        return () => clearInterval(timer);
    }, []);
    useEffect(()=>{
        EtcCtxtApi("CTNT_KIND_ETC","PYMT_GUIDE","BBO").then((resp)=>{
            if(resp.apiHdr.code === "COMM0000") {
                setPymtGuideCtxtState(resp.apiBody.ctxt);
            }
        });
    },[MgpStore.getState().LangSetState.Lang])

    useEffect(() => {
        // 유효한 결과 정보가 없을 때만 홈으로 리다이렉트
        console.log(dpstCode)
        if (!hasResultPayload) {
            navigate('/', { replace: true });
            return;
        }
        let isMounted = true;

        const loadResultData = async () => {
            try {
                if ((dpstCode === "PYMT0000" || dpstCode === "PYMT3502") && dpstOdrNo) {
                    const [orderInfoResult, mnyResult] = await Promise.allSettled([
                        DpstOdrInfotApi(gameSvcCd, dpstOdrNo, lang),
                        MembGameSvcMnyApi(gameSvcCd)
                    ]);

                    if (!isMounted) return;

                    if (orderInfoResult.status === 'fulfilled') {
                        setDpstOdrInfoState(orderInfoResult.value?.apiBody || null);
                    } else {
                        console.error('충전 결과 조회 실패:', orderInfoResult.reason);
                    }

                    if (mnyResult.status === 'fulfilled') {
                        setGameSvcMnyState(mnyResult.value?.apiBody?.totMny ?? "");
                    } else {
                        console.error('재화 조회 실패:', mnyResult.reason);
                    }
                } else {
                    console.log("충전 실패 코드:", dpstCode);
                }
            } finally {
                if (isMounted) {
                    setIsResultLoading(false);
                }
            }
        };

        loadResultData();

        return () => {
            isMounted = false;
        };
    }, [dpstOdrNo, dpstCode, gameSvcCd, hasResultPayload, lang, navigate]);

    useEffect(() => {
        // 렌더링 완료 후 opener 새로고침
        if (window.opener && typeof window.opener.location?.reload === 'function') {
            try {
                if (window.opener && typeof window.opener.GotoDpstLstFunc === 'function') {
                    window.opener.GotoDpstLstFunc();
                }
            } catch (e) {
                console.warn('opener reload failed', e);
            }
        }
    }, []);

    const handleGoToShop = () => {
       window.self.close();
    };

    const resultData = {
        dpstOdrNo,
        dpstCode,
        dpstMsg,
        gameSvcCd,
        pymtMthdNm,
        rcmnPrdtCd,
        prdtNm,
        paidMny,
        freeMny,
        odrAmt,
    };

    return (
        <>
            <Helmet>
                <title>{process.env.REACT_APP_TITLE_PREFIX}{langData?.GAME_DPST_RSLT_TITLE_00 || '충전 완료'}</title>
            </Helmet>
            <div className="container500 gameMnyDpstWrap">
                <ShopDpstResultLayer
                    loading={isResultLoading}
                    resultData={resultData}
                    orderInfo={dpstOdrInfoState}
                    langData={langData}
                    pymtGuideCtxt={pymtGuideCtxtState}
                    totMny={gameSvcMnyState}
                    fallbackPrdtNm={prdtNm}
                    onClose={handleGoToShop}
                    useShopLayout={false}
                    showGuide={true}
                />
            </div>
            
            <style>{`
                .dpstResultItem {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start ;
                    gap: 5px;
                    padding: 5px 0;
                    border-bottom: 1px solid #eee;
                }
                .dpstResultWrap {
                    text-align: center;
                }
                
                .dpstResultHeader {
                    margin-bottom: 30px;
                }
                
                .successIcon {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background-color: #157dfa;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 30px;
                    margin: 0 auto 20px;
                }
                
                .failureIcon {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background-color: #f44336;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 30px;
                    margin: 0 auto 20px;
                }
                
                .warningIcon {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background-color: #ff9800;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 30px;
                    margin: 0 auto 20px;
                }
                
                .dpstResultHeader h1 {
                    color: #333;
                    font-size: 24px;
                    margin: 0;
                }
                
                .dpstResultInfo {
                    background-color: #f8f9fa;
                    border-radius: 8px;
                    margin-bottom: 30px;
                }
                
                
                .dpstResultItem:last-child {
                    border-bottom: none;
                }
                
                .dpstResultItem .label {
                    color: #666;
                    font-size: 14px;
                }
                
                .dpstResultItem .value {
                    font-weight: 400;
                    font-size: 15px;
                    color: #333;
                }
                
                .dpstResultItem .value.highlight {
                    color: #157dfa;
                    font-size: 18px;
                }
                
                .dpstResultNotice {
                    border-radius: 8px;
                    margin-bottom: 30px;
                    text-align: left;
                }
                
                .dpstResultNotice.failure {
                    background-color: #f8d7da;
                    border: 1px solid #f5c6cb;
                }
                
                .dpstResultNotice.warning {
                    background-color: #fff3cd;
                    border: 1px solid #ffeaa7;
                }
                
                .dpstResultNotice h3 {
                    margin: 0 0 10px 0;
                    color: #157dfa;
                }
                
                .dpstResultNotice.failure h3 {
                    color: #721c24;
                }
                
                .dpstResultNotice ul {
                    margin: 0;
                }
                
                .dpstResultNotice li {
                    color: #333;
                    margin-bottom: 5px;
                    font-size: 12px;
                }
                
                .dpstResultNotice.failure li {
                    color: #721c24;
                }
                
                .dpstResultItem .value.error {
                    color: #dc3545;
                    font-weight: bold;
                }
                
                .dpstResultBtnWrap {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                
                .dpstResultBtn {
                    padding: 15px 20px;
                    border: none;
                    border-radius: 8px;
                    font-size: 16px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                
                .dpstResultBtn.primary {
                    background-color: #ff6b35;
                    color: white;
                }
                
                .dpstResultBtn.primary:hover {
                    background-color: #e55a2b;
                }
                
                .dpstResultBtn.secondary {
                    background-color: #6c757d;
                    border: 1px solid #6c757d;
                    color: white;
                }
                
                .dpstResultBtn.secondary:hover {
                    background-color: #157dfa;
                    border-color: #157dfa;
                }
                
                .dpstResultBtn.tertiary {
                    background-color: transparent;
                    color: #6c757d;
                    border: 1px solid #6c757d;
                }
                
                .dpstResultBtn.tertiary:hover {
                    background-color: #157dfa;
                    border-color: #157dfa;
                    color: white;
                }
                
                .loadingWrap {
                    padding: 60px 20px;
                    color: #666;
                }
                
                @media (min-width: 768px) {
                    .dpstResultBtnWrap {
                        flex-direction: row;
                    }
                }
            `}</style>
        </>
    );
};

export default GameMnyDpstResult;